import { createRoute, redirect } from "@tanstack/react-router";
import { Route } from "./__root";

export const generationRoute = createRoute({
  getParentRoute: () => Route,
  path: "/generation",
  beforeLoad: () => {
    throw redirect({ to: "/", replace: true });
  },
});
